import { hasFeature } from '@precert/has-feature';
import { Logger } from '@precert/logger';
import React from 'react';
import { Navigate } from 'react-router-dom';

import type { ConfigType } from './config';
import { useConfig } from './config';

const log = Logger('app:router:route');

export function ProtectedRoute({
  secured,
  feature,
  children,
}: {
  secured?: (config: ConfigType | Record<string, never>) => string[];
  children: React.ReactNode;
  feature?: string;
}) {
  const config = useConfig();
  const { features } = config;
  if (feature && !hasFeature(feature, features)) {
    log.warn('Feature for route [%s] is not enabled.', location.pathname);
    return <Navigate to="/unauthorized" />;
  }

  if (!secured) return children;
}
